module.exports = __webpack_public_path__ + "static/FP_G-5e3fa78970dad5d25356115a38e092c8.svg";